import { Section } from './section';

export class Formulaire {
  public id: number;
  public code: string;
  public intitule: string;
  public typeAvis: string;
  public typeOrganisme: string;
  public typeMarche: string;
  public typeNorme: string;
  public montant: string;
  public directiveAssosciee: string;
  public noticeInformation: string;
  public urlNoticeInformation: string;
  public json: string;
  public sectionList: Section[];

  constructor() {
  }
}
